exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CheckboxCategoryItem{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:8px;font-size:14px;font-weight:500;color:var(--text-primary)}", ""]);

// exports
